<rr-icon name="film" class="roundicon"></rr-icon>
<h2>{{ data.title }}</h2>
<div>{{ data.description }}</div>
@if (data.url.indexOf('youtube') !== -1) {
    <iframe
        [src]="safeUrl"
        [title]="data.title"
        frameborder="0"
        allow="
            accelerometer;
            autoplay;
            clipboard-write;
            encrypted-media;
            gyroscope;
            picture-in-picture;
            web-share;
        "
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
    ></iframe>
} @else {
    <video [poster]="data.thumbnail" [src]="data.url" controls></video>
}
<div class="w100 row space-between gap-16 align-center">
    <div class="col">
        <strong>Having Questions?</strong>
        <div class="tiny">
            Get answers about the Stream or the Video, or anything else you are
            interestetd in.
        </div>
    </div>
    <rr-btn type="Secondary" size="Small">Ask a Question</rr-btn>
</div>
<div class="w100 row justify-end">
    <rr-btn type="Secondary" size="Small" (click)="close()">Close</rr-btn>
</div>
